import React from 'react';

import { Container } from 'components/container/Container';

import s from './Iframe.scss';
import { SectionHeader } from 'components/section-header/SectionHeader';

interface IProps {
  title?: string;
  src: string;
  width?: number;
  height?: number;
}

export const Iframe = ({ title, src, width, height }: IProps) => {
  if (!title && !src) {
    return null;
  }

  const hasRatio = width && height;

  return (
    <div className={s.iframe}>
      {title && <SectionHeader heading={title} />}
      <div className={s.iframe__content}>
        <iframe
          className={s.iframe__iframe}
          src={src}
          frameBorder="0"
          scrolling="no"
          width={width}
          height={height}
        />
        {hasRatio && (
          <div
            className={s.image__ratio}
            style={{ paddingBottom: `${(height! / width!) * 100}%` }}
          />
        )}
      </div>
    </div>
  );
};
